import { render, staticRenderFns } from "./information-card.vue?vue&type=template&id=3459920c&scoped=true"
import script from "./information-card.vue?vue&type=script&lang=js"
export * from "./information-card.vue?vue&type=script&lang=js"
import style0 from "./information-card.vue?vue&type=style&index=0&id=3459920c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459920c",
  null
  
)

export default component.exports